<template>
  <div class="text-center py-2 px-1">
      <span class="titulo-info font-size-1 text-semibold text-uppercase">{{ aItems.Pregunta }}</span>
  </div>
</template>

<script>
  export default {
    name:'SubFormulario',
    props: ['aItems'],
  }
</script>

<style lang="scss" scoped>
.titulo-info{
  color: var(--v-primary-base);
}
</style>